export const apiKey = '008c918ac103184d106e028538da207b';

export const privateApiKey = 'e45106812a661a61c5e813c4fe68e07eab55fc7a';

export const apiConfig = {
  BASE_URL: 'https://gateway.marvel.com/v1/public',
  PATHS: {
    CHARACTERS: '/characters',
    COMICS: '/comics',
    STORIES: '/stories',
  },
};
